import { Link } from 'react-router-dom';
import { companyPath } from '@/lib/routes';
import { cn } from '@/lib/utils';

/**
 * A company name that opens its Orbit (§4.2: every place a company name appears links to Orbit).
 * Renders plain text when there's no Autotask company id. Stops propagation so it works inside
 * clickable table rows.
 */
export function OrbitLink({ companyId, children, className }: { companyId: number | null | undefined; children: React.ReactNode; className?: string }) {
  if (companyId == null) return <span className={className}>{children}</span>;
  return (
    <Link to={companyPath(companyId)} onClick={(e) => e.stopPropagation()} title="Open this client's Orbit"
      className={cn('hover:underline', className)}>
      {children}
    </Link>
  );
}
